import { call, select } from 'redux-saga/effects';
import { selectDeviceType } from 'features/application/applicationSlice';
import { signalingRoomJoined } from 'features/room/actions';
import { isMobileViewport } from './isMobileViewport';
import { applyRemotePinnedPanelsSaga } from './applyRemotePinnedPanelsSaga';

export function* onRoomJoinedSaga(action: ReturnType<typeof signalingRoomJoined>) {
  const { pinnedPanels } = action.payload;

  const deviceType: string = yield select(selectDeviceType);
  const isMobile: boolean = yield call(isMobileViewport, deviceType);

  if (isMobile) {
    return;
  }

  yield call(applyRemotePinnedPanelsSaga, pinnedPanels);
}
